module.exports = __webpack_public_path__ + "montserrat-v13-cyrillic_latin-regular.woff2?4cd0fd34f59af6827ed740223b5ce110";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/montserrat-v13-cyrillic_latin-regular.woff2
// module id = 15
// module chunks = 0